import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  /** Wrapper classes for the confirm (primary) action — keeps legacy Delete / default primary / optional warning. */
  get confirmWrapperClass(): Record<string, boolean> {
    const confirmText = this.data?.confirmButtonText || '';
    const isDelete = confirmText === 'Delete';
    const isWarning = this.data?.confirmVariant === 'warning';
    return {
      'btn-supp': isDelete,
      'btn-2': !isDelete && !isWarning,
      'confirm-dialog__confirm-wrap--warning': !isDelete && isWarning,
    };
  }

  onCloseClick() {
    this.dialogRef.close();
  }
}
